<template>
  <div class="loading_container" v-if="loading">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only"></span>
    </div>
  </div>
  <div class="main" v-else>
    <!-- Side Navbar -->
    <SideBar />
    <!-- Body-Content -->
    <div class="body-content">
      <!-- Top Navbar -->
      <TopBar />
      <!-- Body -->
      <div class="container-fluid body-container">
        <div v-if="activeUser.status == 1">
          <div class="center-block">
            <div>
              <div class="alert alert-warning under-review">
                <i class="fa-solid fa-circle-exclamation"></i>  Seu perfil está sendo analisado pela nossa equipe. Você ainda não pode enviar propostas.
              </div>
            </div>
          </div>
        </div>
        <div class="element" v-else>
          <div class="search-box-container">
            <div class="nav" style="border-radius: 8px 8px 0 0; padding: 15px">
              <h1>
                Minhas propostas
                <span v-if="!listLoading && !listError" class="fs-6">({{ proposalCount }})</span>
              </h1>
              <div class="d-flex" style="align-items: center; gap: 10px">
                <select class="form-select" @change="selectNewStatus($event)" :disabled="listLoading">
                  <option value="">Todas</option>
                  <option value="1">Enviadas</option>
                  <option value="2">Clientes interessados</option>
                  <option value="3">Recusadas</option>
                  <option value="4">Desativadas</option>
                </select>
              </div>
            </div>
          </div>
          <div class="project-list">
            <div class="post_project post_project-active" style="padding: 0px;height: auto"
              :class="{ nopro: proposals && proposals.length === 0 }">
              <div class="loading_container" v-if="listLoading" style="height: 200px">
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only"></span>
                </div>
              </div>
              <div v-else-if="listError" class="create-project">
                <div class="card">
                  <div class="card-body">
                    <h1 class="text-danger">Erro</h1>
                    <p class="text-danger">
                      Ocorreu um erro ao atualizar a lista de propostas.<br />
                      Por favor, tente novamente. Se o problema persistir, atualize a página.
                    </p>
                  </div>
                </div>
              </div>
              <div class="create-project" v-else-if="!proposals || proposals.length === 0">
                <div class="card">
                  <img src="assets/img/project.png" alt="" />
                  <div class="card-body">
                    <h2 class="light">Nenhuma proposta encontrada</h2>
                  </div>
                </div>
              </div>
              <div class="active-project" style="padding:0" v-else>
                <a class="card" style="position: static" v-for="proposal in proposals" :key="proposal.id"
                  :href="'/projeto/' + proposal.project_id">
                  <div class="name">
                    <p>
                      Projeto <br />
                      <span>{{ proposal.title }}</span>
                    </p>
                  </div>
                  <div class="date">
                    <p>
                      Última atualização <br />
                      <span>{{
                        formatTimestamp(proposal.last_update_timestamp)
                      }}</span>
                    </p>
                  </div>
                  <div class="status">
                    <p>
                      Status <br />
                      <span :class="getProposalTextClass(proposal)">
                        {{ formatProposalStatus(proposal) }}</span>
                    </p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style></style>

<script>
import SideBar from "../SideBar.vue";
import TopBar from "../TopBar.vue";
import AssistantManager from "../../../js/services/assistant.js";
import StringUtils from "../../../js/utils/string.js";
import Config from "../../../../resources/config.js";

export default {
  components: { SideBar, TopBar },

  created() {
    this.$store.commit("setActiveSection", "ProposalListPage");
    this.loadProposals();
  },

  data() {
    return {
      proposals: null,
      listLoading: false,
      listError: null,
    };
  },

  computed: {
    loading() {
      return this.$store.state.loading;
    },
    activeUser() {
      return this.$store.state.activeUser
    },

    proposalCount() {
      if (this.proposals) {
        return this.proposals.length;
      }
      return 0;
    },
  },

  methods: {
    async loadProposals() {
      this.$store.commit("setLoading", true);
      try {
        let response = await AssistantManager.getProposals();
        let profile = response.profile;
        this.proposals = response.proposals;
        this.$store.commit("setActiveUser", profile);
        this.$store.commit("setLoading", false);
      } catch (error) {
        this.handleAPIError(error, "propostas");
      }
    },

    getProposalStatus(proposal) {
      return proposal.status
    },

    async selectNewStatus(event) {
      let selectedStatus = event.target.value;
      this.listLoading = true;
      this.listError = null;
      try {
        let response = await AssistantManager.getProposals(selectedStatus);
        this.proposals = response.proposals;
      } catch (err) {
        console.log(err);
        this.listError = err;
      } finally {
        this.listLoading = false;
      }
    },
  },
};
</script>
